module.exports = __webpack_public_path__ + "img/Icon5.0011c9e6.png";